// @flow
import * as React from 'react'
import { wrapWithField } from '../../Field'
import { LightboxBaseField } from '../../../core/LightboxBaseField'
import TrainFinderTool from '../TrainFinderTool'
import trainToString from '../utils/trainToString'

// Types
import type {
  Props as BaseFieldProps,
  Input as InputProps,
} from '../../../core/BaseField'
import type { Train } from 'mz-sdk/services/train/getTrains'
import type { AppearanceTitle } from '../../../core/Lightbox'
import type { TrainInfo } from '../TrainRootField'

export type Props = BaseFieldProps & {
  input: InputProps,
  trainInfo: TrainInfo,
  lightboxTitle?: AppearanceTitle,
  lightboxSubtitle?: AppearanceTitle,
}

/**
 * Desktop version of date selector.
 */
class TrainNumberField extends React.Component<Props> {
  static defaultProps = {
    input: {},
    meta: {},
  }

  renderLightbox = ({ cancel, select, appearance }: *) => {
    return (
      <TrainFinderTool
        onClose={cancel}
        onSelect={select}
        trainInfo={this.props.trainInfo}
        finderAppearance={appearance}
        fieldAppearance={this.props.appearance}
      />
    )
  }

  renderValue = (value: ?Train, render: *) => {
    return render(!value ? null : trainToString(value))
  }

  render() {
    return (
      <LightboxBaseField
        {...this.props}
        renderValue={this.renderValue}
        renderLightbox={this.renderLightbox}
        emptyValue={null}
      />
    )
  }
}

export default wrapWithField(TrainNumberField)
